import { useEffect, useState } from "react";
import { X, AlertTriangle } from "lucide-react";

const formatCode = (code) => (code && code.length ? code.join(" ") : "--");

const ReportIssueModal = ({ open, stratagem, onClose, onSubmit }) => {
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) {
      setNote("");
    }
  }, [open]);

  if (!open || !stratagem) {
    return null;
  }

  const sourceEntries = stratagem.source_codes
    ? Object.entries(stratagem.source_codes)
    : [];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4"
      data-testid="report-modal"
    >
      <div className="hud-card clip-corners max-w-xl w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-white"
          data-testid="report-modal-close"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-center gap-3" data-testid="report-modal-header">
          <AlertTriangle className="h-5 w-5 text-[#FFE800]" />
          <h3 className="font-headings text-2xl uppercase tracking-widest text-white">
            Report Incorrect Code
          </h3>
        </div>
        <p className="mt-2 text-sm text-gray-400" data-testid="report-modal-subtitle">
          Stratagem: <span className="text-white">{stratagem.name}</span>
        </p>
        <div className="mt-4 space-y-2 text-xs text-gray-400" data-testid="report-modal-current">
          <p>Current code: <span className="text-[#FFE800]">{formatCode(stratagem.code)}</span></p>
          <p>Verification status: <span className="text-white">{stratagem.verification_status || "unknown"}</span></p>
        </div>
        <div className="mt-4" data-testid="report-modal-sources">
          <p className="text-xs uppercase tracking-[0.3em] text-gray-500">Sources checked</p>
          {sourceEntries.length === 0 ? (
            <p className="mt-2 text-xs text-gray-500" data-testid="report-modal-sources-empty">
              No source metadata available yet.
            </p>
          ) : (
            <ul className="mt-2 space-y-2">
              {sourceEntries.map(([source, code]) => (
                <li
                  key={source}
                  className="flex items-center justify-between text-xs text-gray-300"
                  data-testid={`report-modal-source-${source}`}
                >
                  <span className="uppercase tracking-[0.2em] text-gray-500">{source}</span>
                  <span className="font-data text-[#FFE800]">{formatCode(code)}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <textarea
          value={note}
          onChange={(event) => setNote(event.target.value)}
          placeholder="Optional note (what seems wrong?)"
          className="mt-4 w-full min-h-[90px] bg-black/50 border border-white/10 text-white text-sm p-3 focus:border-[#FFE800]"
          data-testid="report-modal-note"
        />
        <div className="mt-4 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="border border-white/20 px-4 py-2 text-xs font-data text-white"
            data-testid="report-modal-cancel"
          >
            Cancel
          </button>
          <button
            onClick={() => onSubmit(note)}
            className="bg-[#FFE800] px-4 py-2 text-xs font-headings uppercase tracking-[0.2em] text-black"
            data-testid="report-modal-submit"
          >
            Submit Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportIssueModal;